import { memo } from 'react';

import { parseAirDateToISO } from '@air/utilities';

export type ShareLinkMenuFooterProps = {
  createdAt: string | undefined;
  createdByName: string | undefined;
};

export const ShareLinkMenuFooter = memo(({ createdAt, createdByName }: ShareLinkMenuFooterProps) => (
  <div className="-mx-2 -mb-2 flex flex-col border-t ads:border-t-default border-t-gray-5 px-3.5 py-3 ads:text-metadata text-12 text-gray-9">
    {createdByName && <div data-testid="SHARE_LINK_CREATED_BY">Link created by {createdByName}</div>}
    {createdAt && (
      <time data-testid="SHARE_LINK_CREATED_AT" dateTime={createdAt}>
        {new Date(parseAirDateToISO(createdAt)).toLocaleString()}
      </time>
    )}
  </div>
));

ShareLinkMenuFooter.displayName = 'ShareLinkMenuFooter';
